export const fetchRemoteUrlContent=fetch=>{return({url})=>{return fetch(`/remote-url-content?remote_url=${url}`)}};